import { BaseReportApi } from './api.base';

export class BoxReportApi extends BaseReportApi {

}
